import React, { useEffect, useRef, InputHTMLAttributes } from 'react';

import { useField } from '@unform/core';
import { FormControlLabel, Checkbox as MuiCheckbox } from '@material-ui/core';

interface Props {
  name: string;
  label?: string;
  value?: string;
}

type InputProps = InputHTMLAttributes<HTMLInputElement> & Props;

const Checkbox: React.FC<InputProps> = ({ name, value, label, disabled }) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const { fieldName, defaultValue, registerField, error } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef,
      getValue: (ref) => {
        return ref.current.checked;
      },
      clearValue: (ref) => {
        ref.current.checked = defaultValue;
      },
      setValue: (ref, valuee) => {
        ref.current.checked = valuee;
      },
    });
  }, [defaultValue, fieldName, registerField]);

  return (
    <div>
      <FormControlLabel
        id={fieldName}
        value={value}
        control={
          // eslint-disable-next-line react/jsx-wrap-multilines
          <MuiCheckbox
            inputRef={inputRef}
            defaultChecked={defaultValue}
            disabled={disabled}
          />
        }
        label={label}
        name={name}
      />

      {error && <span>{error}</span>}
    </div>
  );
};

Checkbox.defaultProps = {
  label: 'value',
  value: 'value',
};

export default Checkbox;
